import React, { useMemo, useState } from 'react';
import DatePicker from 'react-datepicker';
import CloseIcon from '@mui/icons-material/Close';
import { useTranslation } from 'react-i18next';
import TextField from '../../Form/TextField/TextField';
import classes from '../scss/addEditFormModal.module.scss';
import CustomCalendarHeader from '../../Form/CalendarInput/CustomCalendarHeader';
import CalendarInput from '../../Form/CalendarInput/CalendarInput';
import { maxSymbolQTY, maxMobileSize, deleteModalConfigs } from '../../../../utils/constants';
import { useWindowSize } from '../../../../utils/hooks';
import { BinOutlinedIcon } from '../../Icons';
import DeleteDialog from '../DeleteDialog';

import('react-datepicker/dist/react-datepicker.css');
import('../../../../scss/datepicker.css');

function TrainingsForm(props) {
  const { addEditForm, deleteHandler } = props;

  const [open, setOpen] = useState(false);
  const { t } = useTranslation();
  const deleteModalConfig = useMemo(() => deleteModalConfigs(t), [t]);
  const size = useWindowSize();

  return (
    <div className={classes.formContainer}>
      <div className={`col-md-3 ${classes.textField}`}>
        <TextField
          id="type"
          name="type"
          placeholder="Type"
          value={addEditForm.values.type}
          onChange={addEditForm.handleChange}
          error={addEditForm.touched.type && Boolean(addEditForm.errors.type)}
          errorText={addEditForm.touched.type && addEditForm.errors.type}
          clearable
          counter={{ qty: addEditForm.values.type?.length, limit: maxSymbolQTY.TYPE }}
        />
        {addEditForm.values.type && (
          <div
            data-testid="clearBtn"
            role="presentation"
            className={classes.closeIcon}
            onClick={() => addEditForm.setFieldValue('type', '', true)}
          >
            <CloseIcon fontSize="8px" />
          </div>
        )}
      </div>
      <div className={`col-md-3 ${classes.textField}`}>
        <TextField
          id="certId"
          name="certId"
          placeholder="Certificate ID"
          value={addEditForm.values.certId}
          onChange={addEditForm.handleChange}
          error={addEditForm.touched.certId && Boolean(addEditForm.errors.certId)}
          errorText={addEditForm.touched.certId && addEditForm.errors.certId}
          clearable
          counter={{ qty: addEditForm.values.certId?.length, limit: maxSymbolQTY.CERTIFICATE_ID }}
        />
        {addEditForm.values.certId && (
          <div
            data-testid="clearBtn"
            role="presentation"
            className={classes.closeIcon}
            onClick={() => addEditForm.setFieldValue('certId', '', true)}
          >
            <CloseIcon fontSize="8px" />
          </div>
        )}
      </div>
      <div className="col-md-3">
        <DatePicker
          disabledKeyboardNavigation
          withPortal={size.width < maxMobileSize}
          portalId="root-portal"
          selected={addEditForm.values.valid}
          name="valid"
          dateFormat="dd MMM yyyy"
          openToDate={new Date()}
          dayClassName={(date) =>
            date.getDate() === new Date().getDate() &&
            addEditForm.values.valid &&
            date.getDate() !== addEditForm.values.valid?.getDate()
              ? classes.customTodayDate
              : undefined
          }
          renderCustomHeader={
            // eslint-disable-next-line react/jsx-props-no-spreading,no-shadow
            (props) => <CustomCalendarHeader {...props} />
          }
          onChange={(e) => addEditForm.setFieldValue('valid', e, true)}
          customInput={
            <CalendarInput
              label="Valid To"
              touched={addEditForm.touched.valid}
              errors={addEditForm.errors.valid}
              showClearBtn
              clearHandler={() => addEditForm.setFieldValue('valid', null, true)}
            />
          }
        />
      </div>
      {!!deleteHandler && (
        <div className={classes.deleteBtn} role="presentation" onClick={() => setOpen(true)}>
          <span>{t('common.general.delete')}</span> <BinOutlinedIcon />
        </div>
      )}
      <DeleteDialog
        open={open}
        closeHandler={() => setOpen(false)}
        confirmHandler={deleteHandler}
        config={deleteModalConfig.trainings}
      />
    </div>
  );
}

export default TrainingsForm;
